import { useState, useEffect } from 'react';

interface CountdownTimerProps {
  expiresAt: Date | string;
  onExpire?: () => void;
  className?: string;
}

export function CountdownTimer({ expiresAt, onExpire, className = '' }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState<string>('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const expiryDate = typeof expiresAt === 'string' ? new Date(expiresAt) : expiresAt;
      const distance = expiryDate.getTime() - new Date().getTime();

      if (distance < 0) {
        setTimeLeft('Expired');
        setIsExpired(true);
        if (onExpire && !isExpired) {
          onExpire();
        }
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (hours > 0) {
        setTimeLeft(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      } else {
        setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, onExpire, isExpired]);

  return (
    <span className={`text-sm text-muted-foreground ${className}`}>
      {isExpired ? (
        <span className="text-destructive font-medium">Code expired</span>
      ) : (
        <>
          Expires in <span className="font-mono font-medium">{timeLeft}</span>
        </>
      )}
    </span>
  );
}
